import { get, readable, writable } from 'svelte/store';
import moment from 'moment-timezone';
export const remoteTimeAdjustmets = writable(null);
const time = readable(moment(), (set) => {
    const i = setInterval(() => {
        if (get(remoteTimeAdjustmets))
            set(moment((Date.now() - (get(remoteTimeAdjustmets).delta)), 'x').tz(get(remoteTimeAdjustmets).timezone));
        else
            set(moment());
    }, 1000);
    return () => {
        clearInterval(i);
    };
});
export default time;
